import Vue from 'vue';
import DepartureCitiesRepository from '@/js/common/Domain/Repository/DepartureCities';
import AlternativeSearchStore from './store/alternativeSearchStore';

export default function (store, context, renderComponent) {
    new AlternativeSearchStore({ model: context.view.model });

    DepartureCitiesRepository.repository.on('add', _.debounce(() => {
        const departureCities = DepartureCitiesRepository.repository.map((departureCity) => ({
           id: departureCity.get('id'),
           name: departureCity.get('name'),
        }));
        store.commit('mapForAlternativeSearch/setDepatrureCities', departureCities);
     }, 1));

    new Vue({
        name: 'AlternativeSearch',
        el: '.js-alternative-departure',
        render: (h) => h(renderComponent, {
            on: {
                startAlternativeSearchManual: (dataCityId) => {
                    if (dataCityId) {
                        store.commit('mapForAlternativeSearch/setVisibleBanner', true);
                        const departureCityNew = DepartureCitiesRepository.repository.get(dataCityId);
                        const tourCriteria = context.model.getTourCriteria().clone();
                        tourCriteria.set('departureCity', departureCityNew);
                        context.goSearch(tourCriteria);
                    }
                },
                startAlternativeSearchAuto: (dataCityId) => {
                    if (dataCityId) {
                        store.commit('mapForAlternativeSearch/setVisibleBanner', false);
                        const departureCityNew = DepartureCitiesRepository.repository.get(dataCityId);
                        const tourCriteria = context.model.getTourCriteria().clone();
                        tourCriteria.set('departureCity', departureCityNew);
                        clearTimeout(context.startSearchFinishService);
                        console.log('Запуск Алтернативного поиска');
                        context.goSearch(tourCriteria);
                    }
                },
            },
        }),
        store,
    });
}
